import type { ITrashIcon } from './helpers';

export const TrashIcon = ({ variant = 'outline', ...rest }: ITrashIcon) => {
	if (variant === 'outline')
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M21.0697 5.23C19.4597 5.07 17.8497 4.95 16.2297 4.86V4.85L16.0097 3.55C15.8597 2.63 15.6397 1.25 13.2997 1.25H10.6797C8.34967 1.25 8.12967 2.57 7.96967 3.54L7.75967 4.82C6.82967 4.88 5.89967 4.94 4.96967 5.03L2.92967 5.23C2.50967 5.27 2.20967 5.64 2.24967 6.05C2.28967 6.46 2.64967 6.76 3.06967 6.72L5.10967 6.52C10.3497 6 15.6297 6.2 20.9297 6.73C20.9597 6.73 20.9797 6.73 21.0097 6.73C21.3897 6.73 21.7197 6.44 21.7597 6.05C21.7897 5.64 21.4897 5.27 21.0697 5.23Z'
					fill='#DF3939'
				/>
				<path
					opacity='0.3991'
					d='M19.2297 8.14C18.9897 7.89 18.6597 7.75 18.3197 7.75H5.67975C5.33975 7.75 4.99975 7.89 4.76975 8.14C4.53975 8.39 4.40975 8.73 4.42975 9.08L5.04975 19.34C5.15975 20.86 5.29975 22.76 8.78975 22.76H15.2097C18.6997 22.76 18.8398 20.87 18.9497 19.34L19.5697 9.09C19.5897 8.73 19.4597 8.39 19.2297 8.14Z'
					fill='#DF3939'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.58008 17C9.58008 16.5858 9.91586 16.25 10.3301 16.25H13.6601C14.0743 16.25 14.4101 16.5858 14.4101 17C14.4101 17.4142 14.0743 17.75 13.6601 17.75H10.3301C9.91586 17.75 9.58008 17.4142 9.58008 17Z'
					fill='#881616'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.75 13C8.75 12.5858 9.08579 12.25 9.5 12.25H14.5C14.9142 12.25 15.25 12.5858 15.25 13C15.25 13.4142 14.9142 13.75 14.5 13.75H9.5C9.08579 13.75 8.75 13.4142 8.75 13Z'
					fill='#881616'
				/>
			</svg>
		);

	if (variant === 'secondary')
		return (
			<svg
				width='16'
				height='17'
				viewBox='0 0 16 17'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M13.5 3.69141H11V3.19141C11 2.79358 10.842 2.41205 10.5607 2.13075C10.2794 1.84944 9.89782 1.69141 9.5 1.69141H6.5C6.10218 1.69141 5.72064 1.84944 5.43934 2.13075C5.15804 2.41205 5 2.79358 5 3.19141V3.69141H2.5C2.36739 3.69141 2.24021 3.74408 2.14645 3.83785C2.05268 3.93162 2 4.0588 2 4.19141C2 4.32401 2.05268 4.45119 2.14645 4.54496C2.24021 4.63873 2.36739 4.69141 2.5 4.69141H3V13.6914C3 13.9566 3.10536 14.211 3.29289 14.3985C3.48043 14.586 3.73478 14.6914 4 14.6914H12C12.2652 14.6914 12.5196 14.586 12.7071 14.3985C12.8946 14.211 13 13.9566 13 13.6914V4.69141H13.5C13.6326 4.69141 13.7598 4.63873 13.8536 4.54496C13.9473 4.45119 14 4.32401 14 4.19141C14 4.0588 13.9473 3.93162 13.8536 3.83785C13.7598 3.74408 13.6326 3.69141 13.5 3.69141ZM6 3.19141C6 3.0588 6.05268 2.93162 6.14645 2.83785C6.24021 2.74408 6.36739 2.69141 6.5 2.69141H9.5C9.63261 2.69141 9.75979 2.74408 9.85355 2.83785C9.94732 2.93162 10 3.0588 10 3.19141V3.69141H6V3.19141ZM12 13.6914H4V4.69141H12V13.6914ZM7 7.19141V11.1914C7 11.324 6.94732 11.4512 6.85355 11.545C6.75979 11.6387 6.63261 11.6914 6.5 11.6914C6.36739 11.6914 6.24021 11.6387 6.14645 11.545C6.05268 11.4512 6 11.324 6 11.1914V7.19141C6 7.0588 6.05268 6.93162 6.14645 6.83785C6.24021 6.74408 6.36739 6.69141 6.5 6.69141C6.63261 6.69141 6.75979 6.74408 6.85355 6.83785C6.94732 6.93162 7 7.0588 7 7.19141ZM10 7.19141V11.1914C10 11.324 9.94732 11.4512 9.85355 11.545C9.75979 11.6387 9.63261 11.6914 9.5 11.6914C9.36739 11.6914 9.24021 11.6387 9.14645 11.545C9.05268 11.4512 9 11.324 9 11.1914V7.19141C9 7.0588 9.05268 6.93162 9.14645 6.83785C9.24021 6.74408 9.36739 6.69141 9.5 6.69141C9.63261 6.69141 9.75979 6.74408 9.85355 6.83785C9.94732 6.93162 10 7.0588 10 7.19141Z'
					fill='#DF3939'
				/>
			</svg>
		);

	if (variant === 'secondary-outline')
		return (
			<svg
				width='37'
				height='37'
				viewBox='0 0 37 37'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.5'
					y='0.191406'
					width='36'
					height='36'
					rx='18'
					fill='#FDF2F2'
				/>
				<path
					d='M26.0001 13.7998C25.9834 13.7998 25.9584 13.7998 25.9334 13.7998C21.5251 13.3581 17.1251 13.1915 12.7667 13.6331L11.0667 13.7998C10.7167 13.8331 10.4084 13.5831 10.3751 13.2331C10.3417 12.8831 10.5917 12.5831 10.9334 12.5498L12.6334 12.3831C17.0667 11.9331 21.5584 12.1081 26.0584 12.5498C26.4001 12.5831 26.6501 12.8915 26.6167 13.2331C26.5917 13.5581 26.3167 13.7998 26.0001 13.7998Z'
					fill='#DF3939'
				/>
				<path
					d='M15.5836 12.9579C15.5503 12.9579 15.517 12.9579 15.4753 12.9496C15.142 12.8912 14.9086 12.5662 14.967 12.2329L15.1503 11.1412C15.2836 10.3412 15.467 9.23291 17.4086 9.23291H19.592C21.542 9.23291 21.7253 10.3829 21.8503 11.1496L22.0336 12.2329C22.092 12.5746 21.8586 12.8996 21.5253 12.9496C21.1836 13.0079 20.8586 12.7746 20.8086 12.4412L20.6253 11.3579C20.5086 10.6329 20.4836 10.4912 19.6003 10.4912H17.417C16.5336 10.4912 16.517 10.6079 16.392 11.3496L16.2003 12.4329C16.1503 12.7412 15.8836 12.9579 15.5836 12.9579Z'
					fill='#DF3939'
				/>
				<path
					d='M21.175 27.1496H15.825C12.9167 27.1496 12.8 25.5412 12.7083 24.2412L12.1667 15.8496C12.1417 15.5079 12.4083 15.2079 12.75 15.1829C13.1 15.1662 13.3917 15.4246 13.4167 15.7662L13.9583 24.1579C14.05 25.4246 14.0833 25.8996 15.825 25.8996H21.175C22.925 25.8996 22.9583 25.4246 23.0417 24.1579L23.5833 15.7662C23.6083 15.4246 23.9083 15.1662 24.25 15.1829C24.5917 15.2079 24.8583 15.4996 24.8333 15.8496L24.2917 24.2412C24.2 25.5412 24.0833 27.1496 21.175 27.1496Z'
					fill='#DF3939'
				/>
				<path
					d='M19.8834 22.5664H17.1084C16.7667 22.5664 16.4834 22.2831 16.4834 21.9414C16.4834 21.5997 16.7667 21.3164 17.1084 21.3164H19.8834C20.2251 21.3164 20.5084 21.5997 20.5084 21.9414C20.5084 22.2831 20.2251 22.5664 19.8834 22.5664Z'
					fill='#DF3939'
				/>
				<path
					d='M20.5837 19.2329H16.417C16.0753 19.2329 15.792 18.9496 15.792 18.6079C15.792 18.2662 16.0753 17.9829 16.417 17.9829H20.5837C20.9253 17.9829 21.2087 18.2662 21.2087 18.6079C21.2087 18.9496 20.9253 19.2329 20.5837 19.2329Z'
					fill='#DF3939'
				/>
			</svg>
		);
	return (
		<svg
			width='24'
			height='25'
			viewBox='0 0 24 25'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				y='0.191406'
				width='24'
				height='24'
				rx='2'
				fill='#F9D7D7'
			/>
			<path
				d='M18.0466 7.67799C16.9733 7.57133 15.8999 7.49133 14.8199 7.43132V7.42466L14.6733 6.55799C14.5733 5.94466 14.4266 5.02466 12.8666 5.02466H11.1199C9.56661 5.02466 9.41994 5.90466 9.31328 6.55132L9.17328 7.40466C8.55328 7.44466 7.93328 7.48466 7.31328 7.54466L5.95328 7.67799C5.67328 7.70466 5.47328 7.95133 5.49994 8.22466C5.52661 8.49799 5.76661 8.69799 6.04661 8.67132L7.40661 8.53799C10.8999 8.19132 14.4199 8.32466 17.9533 8.67799C17.9733 8.67799 17.9866 8.67799 18.0066 8.67799C18.2599 8.67799 18.4799 8.48466 18.5066 8.22466C18.5266 7.95133 18.3266 7.70466 18.0466 7.67799Z'
				fill='#DF3939'
			/>
			<path
				opacity='0.3991'
				d='M16.8197 9.61815C16.6597 9.45149 16.4397 9.35815 16.213 9.35815H7.78634C7.55967 9.35815 7.333 9.45149 7.17967 9.61815C7.02634 9.78482 6.93967 10.0115 6.953 10.2448L7.36634 17.0848C7.43967 18.0982 7.533 19.3648 9.85967 19.3648H14.1397C16.4663 19.3648 16.5597 18.1048 16.633 17.0848L17.0463 10.2515C17.0597 10.0115 16.973 9.78482 16.8197 9.61815Z'
				fill='#DF3939'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.3867 15.5247C10.3867 15.2485 10.6106 15.0247 10.8867 15.0247H13.1067C13.3829 15.0247 13.6067 15.2485 13.6067 15.5247C13.6067 15.8008 13.3829 16.0247 13.1067 16.0247H10.8867C10.6106 16.0247 10.3867 15.8008 10.3867 15.5247Z'
				fill='#881616'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.8335 12.8582C9.8335 12.582 10.0574 12.3582 10.3335 12.3582H13.6668C13.943 12.3582 14.1668 12.582 14.1668 12.8582C14.1668 13.1343 13.943 13.3582 13.6668 13.3582H10.3335C10.0574 13.3582 9.8335 13.1343 9.8335 12.8582Z'
				fill='#881616'
			/>
		</svg>
	);
};
